export const regular = 400;
export const medium = 500;
export const semiBold = 600;
export const bold = 700;
